import routes from './routes'
import * as containers from './containers'

export default {
  containers,
  routes
}



// WEBPACK FOOTER //
// ./src/features/Home/index.js